import { TimeBasedSettingBaseDto, TimeBasedSettingBaseDtoImpl } from './timebasedsettingbasedto';

export interface TimeBasedSettingForAllCallersDto extends TimeBasedSettingBaseDto
{

}

export class TimeBasedSettingForAllCallersDtoImpl extends TimeBasedSettingBaseDtoImpl implements TimeBasedSettingForAllCallersDto
{
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/timebasedsetting/timebasedsettingforallcallersdto.tsx